import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { resetPassword } from '../api';

export default function ResetPassword() {
  const [searchParams]  = useSearchParams();
  const token           = searchParams.get('token');
  const navigate        = useNavigate();

  const [newPassword, setNewPassword] = useState('');
  const [confirm,     setConfirm]     = useState('');
  const [error,       setError]       = useState('');
  const [loading,     setLoading]     = useState(false);

  const handleSubmit = async () => {
    setError('');
    if (newPassword !== confirm)  return setError('Passwords do not match.');
    if (newPassword.length < 8)   return setError('Password must be at least 8 characters.');
    setLoading(true);
    try {
      await resetPassword({ token, newPassword });
      navigate('/login?reset=success');
    } catch (err) {
      setError(err.response?.data?.error || 'Invalid or expired reset link.');
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div style={{
        display:        'flex',
        alignItems:     'center',
        justifyContent: 'center',
        minHeight:      '100vh',
        background:     '#f9fafb',
      }}>
        <div style={{ width: '100%', maxWidth: 400, padding: '0 24px' }}>
          <div style={{
            background:   'white',
            borderRadius: 12,
            padding:      '32px',
            boxShadow:    '0 4px 24px rgba(0,0,0,0.08)',
            border:       '1px solid #f0f0f0',
            textAlign:    'center',
          }}>
            <div style={{ fontSize: 40, marginBottom: 16 }}>⚠️</div>
            <h2 style={{ margin: '0 0 12px', fontSize: 18, fontWeight: 600, color: '#111827' }}>
              Invalid reset link
            </h2>
            <p style={{ margin: '0 0 24px', fontSize: 14, color: '#6b7280' }}>
              This link is missing or malformed. Please request a new one.
            </p>
            <Link to="/forgot-password" style={{
              display:        'inline-block',
              padding:        '10px 24px',
              borderRadius:   8,
              background:     '#1e3a5f',
              color:          'white',
              textDecoration: 'none',
              fontSize:       14,
              fontWeight:     600,
            }}>
              Request new link
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      display:        'flex',
      alignItems:     'center',
      justifyContent: 'center',
      minHeight:      '100vh',
      background:     '#f9fafb',
    }}>
      <div style={{ width: '100%', maxWidth: 400, padding: '0 24px' }}>

        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <span style={{ fontSize: 48 }}>🛡️</span>
          <h1 style={{ margin: '8px 0 4px', fontSize: 28, fontWeight: 700, color: '#111827' }}>
            RegShield
          </h1>
          <p style={{ margin: 0, fontSize: 14, color: '#6b7280' }}>
            Compliance Platform — Luxembourg
          </p>
        </div>

        {/* Card */}
        <div style={{
          background:   'white',
          borderRadius: 12,
          padding:      '32px',
          boxShadow:    '0 4px 24px rgba(0,0,0,0.08)',
          border:       '1px solid #f0f0f0',
        }}>
          <h2 style={{ margin: '0 0 8px', fontSize: 18, fontWeight: 600, color: '#111827' }}>
            Set a new password
          </h2>
          <p style={{ margin: '0 0 24px', fontSize: 14, color: '#6b7280' }}>
            Choose a strong password for your account.
          </p>

          {error && (
            <div style={{
              background:   '#fee2e2',
              border:       '1px solid #fca5a5',
              borderRadius: 8,
              padding:      '10px 14px',
              marginBottom: 20,
            }}>
              <p style={{ margin: 0, fontSize: 13, color: '#991b1b', fontWeight: 500 }}>
                {error}
              </p>
            </div>
          )}

          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', fontSize: 13, fontWeight: 500, color: '#374151', marginBottom: 6 }}>
              New password
            </label>
            <input
              type="password"
              placeholder="••••••••"
              value={newPassword}
              onChange={e => setNewPassword(e.target.value)}
              style={{
                width:        '100%',
                padding:      '10px 12px',
                borderRadius: 8,
                border:       '1px solid #e5e7eb',
                fontSize:     14,
                color:        '#111827',
                outline:      'none',
                boxSizing:    'border-box',
              }}
            />
          </div>

          <div style={{ marginBottom: 24 }}>
            <label style={{ display: 'block', fontSize: 13, fontWeight: 500, color: '#374151', marginBottom: 6 }}>
              Confirm new password
            </label>
            <input
              type="password"
              placeholder="••••••••"
              value={confirm}
              onChange={e => setConfirm(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && handleSubmit()}
              style={{
                width:        '100%',
                padding:      '10px 12px',
                borderRadius: 8,
                border:       '1px solid #e5e7eb',
                fontSize:     14,
                color:        '#111827',
                outline:      'none',
                boxSizing:    'border-box',
              }}
            />
          </div>

          <button
            onClick={handleSubmit}
            disabled={loading}
            style={{
              width:        '100%',
              padding:      '11px',
              borderRadius: 8,
              background:   loading ? '#93c5fd' : '#1e3a5f',
              color:        'white',
              border:       'none',
              fontSize:     14,
              fontWeight:   700,
              cursor:       loading ? 'not-allowed' : 'pointer',
              transition:   'background 0.15s',
            }}
          >
            {loading ? 'Updating…' : 'Set new password'}
          </button>

          <p style={{ textAlign: 'center', marginTop: 16, margin: '16px 0 0' }}>
            <Link to="/login" style={{ color: '#1e3a5f', textDecoration: 'none', fontSize: 13, fontWeight: 500 }}>
              ← Back to login
            </Link>
          </p>
        </div>

        {/* Footer */}
        <p style={{ textAlign: 'center', marginTop: 24, fontSize: 12, color: '#9ca3af' }}>
          RegShield — CSSF · DORA · GDPR Compliant
        </p>

      </div>
    </div>
  );
}